let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("75rqy")).then(() => parcelRequire('36Q2c'));